import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import router from "@/router";
  import { formatDate } from "@/helpers/date";
  import { formatPrice } from "@/helpers/transformation/price";
  import { LotStatus } from "@/enums/LotStatus";
  import { getDocumentName } from "@/helpers/documents";
  import { getLotStatusClass } from "@/helpers/status";
  import BuilderLotDocuments from "./BuilderLotDocuments.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderLotDetails',
  props: {
    lot: {
      type: Object,
      required: true,
    },
    estate: {
      type: Object,
      required: true,
    },
    isBuilderView: {
      type: Boolean,
      required: false,
    },
  },
  emits: ["close", "toContact"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const { isDesktop } = useIsDesktop(990);
  const emits = __emit;
  const props = __props;
  const toContact = () => {
    emits("toContact");
  };

const __returned__ = { isDesktop, emits, props, toContact, computed, ref, onMounted, Modal, get router() { return router }, get formatDate() { return formatDate }, get formatPrice() { return formatPrice }, get LotStatus() { return LotStatus }, get getDocumentName() { return getDocumentName }, get getLotStatusClass() { return getLotStatusClass }, BuilderLotDocuments, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})